import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@material-ui/core';
import { useMobile } from '../../hooks/utilHooks';
import Carousel from 'react-multi-carousel';
import RenderUserCardItem from './renderUserCardItem';

const CoordinatorCarousel = ({ post, cards }) => {
  const isMobile = useMobile();
  const [showDots, setShowDots] = useState(true);

  useEffect(() => {
    if (isMobile && cards.length <= 3) {
      setShowDots(false);
    } else if (!isMobile && cards.length <= 3) {
      setShowDots(false);
    }
  }, [isMobile, cards.length]);

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 3,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
    },
  };

  return (
    <React.Fragment>
      <Box height={isMobile ? '320px' : '300px'} bgcolor="#f5f5f5">
        <Box py={3}>
          <Typography variant="body2">{post.title}</Typography>
        </Box>
        <Carousel
          responsive={responsive}
          removeArrowOnDeviceType={['tablet', 'mobile']}
          showDots={showDots}
          className="feedChapterCarousel"
        >
          {cards &&
            cards.map((card, index) => (
              <RenderUserCardItem card={card} index={index} key={index} />
            ))}
        </Carousel>
      </Box>
    </React.Fragment>
  );
};
export default CoordinatorCarousel;
